import Vue from "vue";

export function getRoomCamera(options) {
  return new Promise((resolve, reject) => {
    Vue.onesocket.send({
      function: "loadCameras",
      module: "SQMOD_CameraDialog",
      data: { ...options },
      onMessage: function (data) {
        if (data.payload.root && Array.isArray(data.payload.root)) {
          data.payload.root.forEach((item) => {
            if (item.image_base64) {
              item.image_base64 = "data:image/jpeg;base64," + item.image_base64;
            }
          });
        }
        resolve(data.payload.root);
      },

      onError: function (error) {
        reject(error);
        Vue.logger("api-roomcamera", "failed loading room-camera", error);
      },
    });
  });
}
